import {useContext, useEffect, useState} from 'react';
import {AppContext} from '../../context/AppProvider';
import {FundamntProgramType} from '../../interface';
import getLocalizedContent from '../../lib/getLocalizedMetaData';
import {filterEnrollmentData, weekCount} from '../../lib/utils';
import {apis} from '../../services/alm';
import FundamentalProgramCard from './FundamentalProgramCard/FundamentalProgramCard';
import { ActionType } from '../../assets/constants/constants';

const FundamentalProgram = ({showSeeAll}: {showSeeAll?: boolean}) => {
  const {state,dispatch} = useContext(AppContext);
  const [fundamentalProgramData, setFundamentalProgram] = useState<FundamntProgramType>({
    bannerUrl: '',
    name: '',
    overview: '',
    weeks: 0,
    tags: '',
    progress: 0,
    date: '',
    description: '',
    included: [],
    relationShipId: '',
    programStatus:''
  });

  const fundamentalProgram = async () => {
    try{
      const apiResponseData: any = await apis.getFundamentalProgramList(state.fundamenalCatlogId);
      dispatch({type: ActionType.FUNDAMENTAL_PROGRAM_ID, payload: apiResponseData?.id})
      const enrollmentId = apiResponseData.data[0]?.relationships?.enrollment?.data?.id;
      const enrollmentData = filterEnrollmentData(apiResponseData, enrollmentId);
      const content = getLocalizedContent(apiResponseData.data[0].attributes?.localizedMetadata);
      setFundamentalProgram({
        tags: apiResponseData.data[0].attributes?.tags[0],
        bannerUrl: apiResponseData.data[0].attributes?.bannerUrl,
        name: content?.name,
        overview: content?.overview,
        weeks: weekCount(apiResponseData),
        progress: enrollmentData?.progressPercent,
        date: apiResponseData.data[0].attributes?.dateCreated,
        description: content?.description,
        included: apiResponseData?.included,
        relationShipId: apiResponseData?.data[0]?.relationships?.instances?.data[0]?.id,
        programStatus:enrollmentData?.state
      });
    }catch(error:any){
      console.log('fundamental program card ---->',error)
      setFundamentalProgram({  bannerUrl: '', name: '', overview: '',
        weeks: 0,   tags: '',   progress: 0,   date: '',  
        description: '',   included: [],  relationShipId: '',
      })
    }
    
  };
  useEffect(() => {
    if (state.user) {
      fundamentalProgram();
    }
  }, [state.user]);

  return (
    <>
      {fundamentalProgramData && (
        <FundamentalProgramCard cardInfo={fundamentalProgramData} showSeeAll={showSeeAll} />
      )}
    </>
  );
};

export default FundamentalProgram;
